import { Connection } from './connectionFingerprintReducer'

export const lockCurve = (widgetId: number, assetType:string, connection: Connection): void => {
    const {connection_start, duration} = connection
    fetch(`/services/plugin-drilling-widgets/connectionfingerprint/${assetType}/${widgetId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            connection_start, duration
        })
    }).then(r => {
        console.log(r)
    })
}

export const unlockCurve = (widgetId: number, assetType:string, connection: Connection): void => {
    const {connection_start, duration} = connection
    fetch(`/services/plugin-drilling-widgets/connectionfingerprint/${assetType}/${widgetId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            connection_start, duration
        })
    }).then(r => {
        console.log(r)
    })
}
